import { ThemeProvider } from '@mui/material';
import { getTheme } from '@parsys/frontend_library';
import { ErrorBoundary } from '@sentry/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import AddressSearchFieldComponent from './AddressSearchFieldComponent';
import ErrorFallback from 'FRONTEND/components/ErrorFallback';
import { THEME_APP_NAME } from 'FRONTEND/utils/constants';

export default (element) => {
  const root = createRoot(element);
  const theme = getTheme({ app: THEME_APP_NAME, branding: window.branding });
  root.render(
    <ErrorBoundary fallback={<ErrorFallback />}>
      <ThemeProvider theme={theme}>
        <AddressSearchFieldComponent
          id={element.dataset.id}
          label={element.dataset.label}
          values={element.dataset.values}
          bindToFieldsIds={element.dataset.bindToFieldIds ? JSON.parse(element.dataset.bindToFieldIds) : null}
          examType={element.dataset.examType}
          context={element.dataset.context}
        />
      </ThemeProvider>
    </ErrorBoundary>,
  );
};
